import { render, staticRenderFns } from "./body.vue?vue&type=template&id=a65f2d24&"
import script from "./body.vue?vue&type=script&lang=js&"
export * from "./body.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports